import {
   destinationValueSetter,
   marketIdValueSetter,
   originValueSetter,
} from '../../../utils/column-validators';

export const MARKET_LIST_TABLE_HEADERS = [
   {
      field: 'marketId',
      headerName: 'ID',
      headerTooltip: 'ID',
      editable: true,
      valueSetter: marketIdValueSetter,
   },
   {
      field: 'origin',
      headerName: 'ORG',
      headerTooltip: 'Origin',
      editable: true,
      valueSetter: originValueSetter,
   },
   {
      field: 'destination',
      headerName: 'DES',
      headerTooltip: 'Destination',
      editable: true,
      valueSetter: destinationValueSetter,
   },
   {
      field: 'user',
      headerName: 'User',
      headerTooltip: 'User',
   },
   {
      field: 'lastUpdatedAt',
      headerName: 'Last Updated',
      headerTooltip: 'Last Updated',
   },
];
